import { client, getErrorMessage } from "./client";
import { InspModelItem } from "@types";

const baseUrl = "/insp-model";

export const getInspModels = async (params?: {
  page?: number;
  pageSize?: number;
}) => {
  try {
    const response = await client.get(`${baseUrl}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 전체 배열 반환 (모델 선택 드롭다운 등)
export const getSimpleInspModelList = async () => {
  const response = await client.get(`${baseUrl}/simple`);
  return response.data;
};

// 검사관리 목록용 페이지 조회 (page를 보내면 { total_count, contents } 반환)
export const getPagedInspModelList = async (params: {
  page: number;
  size?: number;
  keyword?: string;
  sort_type?: "name" | "create_at";
  sort?: "asc" | "desc";
}): Promise<{ total_count: number; contents: InspModelItem[] }> => {
  const response = await client.get(`${baseUrl}/simple`, { params });
  return response.data;
};

// 학습모델 리스트 전체 조회
export const getTrainModels = async (params: {
  page: number;
  pageSize: number;
}) => {
  try {
    const response = await client.get(`${baseUrl}/trainmodel`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInspModel = async (
  id: number | string,
  params?: { omit?: "options" },
) => {
  try {
    const response = await client.get(`${baseUrl}/${id}`, { params });
    return response.data.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    throw new Error(errorMessage);
  }
};

export const promoteInspModel = async (ids: number[]) => {
  try {
    const response = await client.post(`${baseUrl}/promote`, { ids });
    return response.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    throw new Error(errorMessage);
  }
};

export const editInspModel = async (
  id: number,
  data: { name?: string; description?: string },
) => {
  try {
    const response = await client.patch(`${baseUrl}/${id}`, data);
    return response.data.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    throw new Error(errorMessage);
  }
};

export const deleteInspModel = async (id: number) => {
  try {
    await client.delete(`${baseUrl}/${id}`);
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    throw new Error(errorMessage);
  }
};
